import { cn, Text } from "@aurem/ui";
import { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  label: string;
  onClick: () => void;
};

export const ControlItem = ({ icon, label, onClick }: Props) => {
  return (
    <button
      className={cn(
        "flex items-center p-2 hover:bg-neutral-500/5 rounded-lg text-start",
        "focus-visible:outline focus-visible:outline-primary-500 focus-visible:outline-offset-[2px]",
      )}
      onClick={onClick}
    >
      <span className="flex justify-center items-center w-8 h-8 shrink-0 p-2">
        {icon}
      </span>
      <Text as="span" size="sm">
        {label}
      </Text>
    </button>
  );
};
